import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { ACCOUNT_INFO } from 'events/types';
import { getAccountData } from 'services/accounts';

import ProfileSidebar from './ProfileSidebar';

import './profile-tables.css';

const Profile = () => {
  const location = useLocation();

  const accountInfoQuery = useQuery({
    queryKey: [ACCOUNT_INFO],
    queryFn: getAccountData,
    select: (response) => response.data.data,
  });

  const isSubUser = accountInfoQuery.data?.isSubUser;

  if (accountInfoQuery.isLoading) {
    return (
      <div className="bg-white">
        <div className="flex h-64 items-center justify-center">Loading...</div>
      </div>
    );
  }

  if (location.pathname.includes('/profile/details') && isSubUser === true) {
    return <Navigate to="/profile/password" replace />;
  }
  if (location.pathname.includes('/profile/subuser') && isSubUser === true) {
    return <Navigate to="/profile/password" replace />;
  }
  if (location.pathname.includes('/profile/payment') && isSubUser === true) {
    return <Navigate to="/profile/password" replace />;
  }

  return (
    <div className="grid grid-cols-1 gap-[0px] lg:gap-[20px] lg:grid-cols-[repeat(auto-fit,minmax(200px,1fr))]">
      <ProfileSidebar isSubUser={isSubUser} />
      <div className="profile-content col-span-4 w-full bg-white p-[16px] md:border-[8px] md:border-[#F6F6F6] md:p-[24px]">
        <Outlet />
      </div>
    </div>
  );
};

export default Profile;
